<template>
  <v-dialog :value="true" persistent max-width="600px">
    <v-card>
      <v-card-title v-if="title">
        <v-row>
          <v-col col="12" align="center">
            <span class="headline">{{ title }}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col col="12" align="center">
            <p>{{ text }}</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-5">
        <v-spacer />
        <v-btn @click="accept()" color="success" >{{ okText }}</v-btn>
        <v-btn @click="refuse()" color="error" >{{ $t('ConfirmationModal.cancel') }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmationModal',
    props: {
      title: {type: String, required: false},
      text: {type: String, required: true},
      acceptText: {type: String, required: false},
      accept: {type: Function, required: true},
      refuse: {type: Function, required: true},
    },
    computed: {
      okText() {
        return this.acceptText || this.$t('ConfirmationModal.ok')
      }
    }
  }
</script>
